import { ArrowRight } from 'lucide-react';
import { useQuiz } from '../../context/QuizContext';
import { CharacterPortrait } from '../CharacterPortrait/CharacterPortrait';
import { GameShell } from '../layout/GameShell';
import { getBiomeTheme } from '../../utils/biomeTheme';

export const ErrorPortal = () => {
  const { state, dispatch } = useQuiz();
  const erro = state.perguntaErro;

  if (!erro) return null;

  return (
    <GameShell maxWidth="xl" maxHeightCeiling="max-h-[100dvh]" frameRgb={getBiomeTheme(state.faseAtual).rgb} className="text-center">

      {/* Módulo coeso (retrato + dossiê) centralizado no espaço restante, SEM rolagem.
          A folga da tela vira margem simétrica externa; o botão fica ancorado no rodapé. */}
      <div className="flex-1 min-h-0 w-full flex flex-col justify-center gap-3">

        {/* Topo — Retrato + Subtítulo */}
        <div className="flex flex-col items-center">
          <CharacterPortrait
            fase={state.faseAtual}
            variant="portal"
            mood="error"
            eager
            className="mb-1"
          />
          <p className="text-red-400 uppercase tracking-widest text-[10px] font-cyber font-bold">
            Resposta Incorreta (-1 Búzio Vital)
          </p>
        </div>

        {/* Dossiê de estudo educativo — sem overflow: L1 proíbe rolagem em gameplay */}
        <div className="bg-slate-900/90 border border-slate-700/80 rounded-2xl p-3.5 text-left w-full shadow-2xl flex flex-col gap-2.5">
          <p className="text-slate-100 font-bold text-fluid-body pb-2 border-b border-slate-700/50 leading-snug">
            {erro.pergunta}
          </p>

          <div>
            <p className="text-emerald-400 text-fluid-sm font-cyber font-bold uppercase tracking-wider mb-0.5">
              A resposta correta:
            </p>
            <p className="text-emerald-300 font-bold text-fluid-subtitle">
              {erro.opcoes[erro.correta_index]}
            </p>
          </div>

          <div className="bg-slate-950/60 p-3 rounded-xl border border-slate-800">
            <p className="text-slate-300 text-fluid-body leading-relaxed">
              <strong className="text-amber-400/90 mr-1">Contexto:</strong>{erro.feedback_estudo}
            </p>
          </div>

          {erro.biografia_url && (
            <a
              href={erro.biografia_url}
              target="_blank"
              rel="noopener noreferrer"
              className="pt-1 inline-flex items-center gap-1.5 text-sky-400 hover:text-sky-300 text-fluid-sm font-cyber font-bold uppercase tracking-wider transition-colors self-start"
            >
              Ler a biografia completa <ArrowRight size={12} />
            </a>
          )}
        </div>
      </div>

      {/* Botão Ação Primária na Zona do Polegar (rodapé fixo, fora do miolo) */}
      <button
        onClick={() => dispatch({ type: 'CLOSE_ERROR_PORTAL' })}
        className="btn-cyber bg-slate-800 hover:bg-slate-700 border border-slate-600 text-white font-cyber font-bold py-3 px-6 rounded-xl transition flex items-center gap-2 w-full justify-center text-fluid-body shrink-0 uppercase tracking-wider shadow-lg mt-3"
      >
        Continuar <ArrowRight size={16} />
      </button>

    </GameShell>
  );
};

